<template>
  <div>
    <tr>
      <td class="tabla_venta_producto text_left">{{ venta.nombre }}</td>
      <td class="tabla_venta_cantidad">{{ venta.cantidad }}</td>
      <td class="tabla_venta_monto">${{ dotsCadaTres(parseFloat(venta.precio_total).toFixed(2).replace(/\.00$/, '')) }}</td>
      <td class="tabla_venta_sub_desglosado">{{ venta.cantidad_socio }}</td>
      <td class="tabla_venta_sub_desglosado">${{ dotsCadaTres(parseFloat(venta.facturado_socio).toFixed(2).replace(/\.00$/, '')) }}</td>
      <td class="tabla_venta_sub_desglosado">{{ venta.cantidad_no_socio }}</td>
      <td class="tabla_venta_sub_desglosado">${{ dotsCadaTres(parseFloat(venta.facturado_no_socio).toFixed(2).replace(/\.00$/, '')) }}</td>
    </tr>
    <ProductoListaItemTalle
      v-for="talle in talles"
      :talle="talle"
      :key="talle.talle_id"
    ></ProductoListaItemTalle>
    <!-- <tr v-if="venta.talles.length !== 0">
      <td>{{ venta.talles[0].talle_nombre }}</td>
      <td></td>
      <td></td>
      <td></td>
      <td></td>
      <td></td>
      <td></td>
    </tr> -->
    <!-- <tr v-if="venta.talles.length !== 0">
      <td>{{ venta.talles[0].colores[0].color_nombre }}</td>
      <td>{{ venta.talles[0].colores[0].cantidad }}</td>
      <td>${{ dotsCadaTres(parseFloat(venta.talles[0].colores[0].precio_total).toFixed(2).replace(/\.00$/, '')) }}</td>
      <td>{{ venta.talles[0].colores[0].cantidad_socio }}</td>
      <td>${{ dotsCadaTres(parseFloat(venta.talles[0].colores[0].facturado_socio).toFixed(2).replace(/\.00$/, '')) }}</td>
      <td>{{ venta.talles[0].colores[0].cantidad_no_socio }}</td>
      <td>${{ dotsCadaTres(parseFloat(venta.talles[0].colores[0].facturado_no_socio).toFixed(2).replace(/\.00$/, '')) }}</td>
    </tr> -->
  </div>
</template>

<script>
import ProductoListaItemTalle from '../components/ProductoListaItemTalle.vue'
export default {
  name: 'VentasListaCarritoItem',
  components: {
    ProductoListaItemTalle
  },
  props: ['venta'],
  data: function () {
    return {
      talles: this.venta.talles
    }
  },
  methods: {
    dotsCadaTres (dni) {
      const number = dni.toString().replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1.')
      return number
    }
  },
  computed: {
    // imagenRuta: function () {
    //   return `${PATH_IMG}/${this.comercio.imagen}`
    // }
  }
}
</script>
